import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { DiagnosticsIndexComposite } from "@/domains/diagnostics/index/components/composables/diagnostics-index-composite"
import { createBreadcrumbItem } from "@/domains/diagnostics/utils/breadcrumb-helpers"

export default function DiagnosticsIndexPage() {
  return (
    <PageContainer>
      <MetaData title="Diagnostics" />
      <PageTitle
        title="Diagnostics"
        subTitle="System diagnostics and monitoring tools"
        items={[
          createBreadcrumbItem("more", "More", "/"),
          createBreadcrumbItem("diagnostics", "Diagnostics", "/diagnostics", true),
        ]}
      />
      <DiagnosticsIndexComposite />
    </PageContainer>
  )
}
